import { Box, Result } from '@/lib/types';
import { AxiosError } from 'axios';
import { media_client } from '../../';

export default {
    async deleteCategory(id: number){

        try{

            await media_client.delete(`/categories/${id}`);
            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }
        
    },
    async getCategory(id: number): Promise<Result<{ name: string, id: number, tickets: string[] }, AxiosError>>{

        try{

            const categories = await media_client.get(`/categories/${id}`);
            return {
                ok: new Box<{ name: string, id: number, tickets: string[] }>(categories.data.category as { name: string, id: number, tickets: string[] }),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async getAllCategoryNames(): Promise<Result<{ name: string, id: number, tickets: string[] }[], AxiosError>>{

        try{

            const categories = await media_client.get('/categories');
            return {
                ok: new Box<{ name: string, id: number, tickets: string[] }[]>(categories.data.categories as { name: string, id: number, tickets: string[] }[]),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async editCategory(id: number, name: string, tickets: string[]): Promise<Result<boolean, AxiosError>>{

        try{

            await media_client.post('/categories', {
                name,
                id,
                tickets
            });

            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async createCategory(name: string, tickets: string[]): Promise<Result<boolean, AxiosError>>{

        try{

            await media_client.put('/categories', {
                name,
                tickets
            });

            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    }

}